"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaignAttributesPlugin = void 0;
const omitEmptyProperties_1 = require("../lib/omitEmptyProperties");
const sessionId_1 = require("./sessionId");
const utm_campaignParams = ['source', 'medium', 'campaign', 'content', 'term'];
const getTransform = (prefix = 'context') => (ctx) => {
    var _a, _b, _c;
    try {
        const attributes = Object.assign(Object.assign({}, ((_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a[prefix]) === null || _b === void 0 ? void 0 : _b.campaign) !== null && _c !== void 0 ? _c : {})), getAttributes());
        ctx.updateEvent(`${prefix}.campaign`, attributes);
    }
    catch (e) { }
    return ctx;
};
exports.campaignAttributesPlugin = {
    name: 'Campaing Attributes',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    identify: getTransform('traits'),
    page: getTransform(),
    track: getTransform(),
};
function getAttributes() {
    const queryParamsString = window.location.search;
    const queryParams = new URLSearchParams(queryParamsString);
    const campaignObject = {};
    for (let campaignParam of utm_campaignParams) {
        const queryParamsSelector = queryParams.get(`utm_${campaignParam}`) || '';
        const isXssPattern = sessionId_1.xssPatterns.some(pattern => pattern.test(queryParamsSelector) || pattern.test(decodeURIComponent(queryParamsSelector)));
        if (!isXssPattern) {
            campaignObject[campaignParam] = queryParams.get(campaignParam);
        }
    }
    return (0, omitEmptyProperties_1.omitEmptyProperties)(campaignObject);
}
//# sourceMappingURL=campaignAttributes.js.map